;(function () {
  angular
    .module('contrast.vulnerabilities')
    .factory('traceCommonRenderService', traceCommonRenderServiceFactory)

  function traceCommonRenderServiceFactory(
    _,
    he,
    $sce,
    $http,
    $translate,
    $window,
    logger,
    $rootScope,
    permissions,
    dialogs,
    $uibModal,
    traceRenderers,
    syntaxHighlighter,
    VULN_REQUEST_EVENTS
  ) {
    'ngInject'

    return {
      getTraceStory: getTraceStory,
      activeTabs: activeTabs,
      getRecommendation: getRecommendation,
      selectProperty: selectProperty,
      showAllStacktraces: showAllStacktraces,
      showLessStacktraces: showLessStacktraces,
      getHttpRequest: getHttpRequest,
      replay: replay,
      getTraceServer: getTraceServer,
      getTraceRequirements: getTraceRequirements,
      getTrace: getTrace,
      loadNotes: loadNotes,
      compareDates: compareDates,
      securityControlDialog: securityControlDialog,
      getTraceRoutes: getTraceRoutes,
      getVulnerabilityInstanceMetadata: getVulnerabilityInstanceMetadata,
      getVulnerabilityInstancesDetails: getVulnerabilityInstancesDetails
    }

    function getTraceStory(scope, story, customRisk) {
      var chapters = angular.copy(story.chapters)
      if (chapters != null) {
        for (var i = 0; i < chapters.length; i++) {
          var chapter = chapters[i]
          var options = chapter.introTextVariables
          if (options == undefined) {
            options = {}
          }
          chapter.introText = chapter.introTextFormat
            ? mustache.render(
                chapter.introTextFormat,
                angular.extend(traceRenderers, options)
              )
            : ''
          options = chapter.bodyFormatVariables
          if (options == undefined) {
            options = {}
          }
          chapter.originalBody = chapter.body

          if (/[<>]/.test(chapter.body)) {
            chapter.bodyFormat = _.escape(chapter.bodyFormat)
          }

          if (chapter.type == 'source') {
            chapter.body = chapter.bodyFormat
              ? mustache.render(
                  chapter.bodyFormat,
                  angular.extend(traceRenderers, options)
                )
              : ''
          } else if (chapter.type == 'location') {
            chapter.body = chapter.bodyFormat
              ? mustache.render(
                  chapter.bodyFormat,
                  angular.extend(traceRenderers, options)
                )
              : ''
            // don't mess with chapter.body - leave it alone!
          } else if (chapter.type == 'dataflow') {
            chapter.body = chapter.bodyFormat
              ? mustache.render(
                  chapter.bodyFormat,
                  angular.extend(traceRenderers, options)
                )
              : ''
          } else if (chapter.type == 'properties') {
            for (var property in chapter.properties) {
              const markupVariableOrValue =
                chapter.properties[property].markupVariable ||
                chapter.properties[property].value
              const template =
                chapter.properties[property].markupVariable != null
                  ? chapter.properties[property].markupVariable
                  : chapter.properties[property].value
              chapter.properties[property].value = toTrusted(
                markupVariableOrValue
                  ? mustache.render(
                      template,
                      angular.extend(traceRenderers, options)
                    )
                  : ''
              )
            }
          } else {
            chapter.body = chapter.bodyFormat
              ? mustache.render(
                  chapter.bodyFormat,
                  angular.extend(traceRenderers, options)
                )
              : ''
          }
        }
      }
      scope.model.traceUuid = story.traceId
      scope.model.chapters = chapters

      scope.model.risk = story.risk.formattedText
        ? mustache.render(
            story.risk.formattedText,
            angular.extend(traceRenderers, story.risk.formattedTextVariables)
          )
        : ''

      scope.model.customRisk = customRisk
        ? mustache.render(
            customRisk.formattedText,
            angular.extend(traceRenderers, customRisk.formattedTextVariables)
          )
        : ''
    }

    function toTrusted(htmlCode) {
      return $sce.trustAsHtml(htmlCode)
    }

    function activeTabs(scope, data) {
      switch (data.tab) {
        case 'summary':
          scope.model.summary.active = true
          break
        case 'howtofix':
          scope.model.howtofix.active = true
          break
        case 'httpinfo':
          scope.model.httpinfo.active = true
          break
        case 'details':
          scope.model.details.active = true
          break
        case 'notes':
          scope.model.notes.active = true
          break
        case 'discussion':
          scope.model.discussion.active = true
          break
        default:
        // do nothing
      }
    }

    function getRecommendation(scope, data) {
      var options = data.recommendation.formattedTextVariables
      angular.extend(options, traceRenderers)
      scope.model.owasp = data.owasp
      scope.model.cwe = data.cwe

      scope.model.recommendation = data.recommendation.formattedText
        ? mustache.render(data.recommendation.formattedText, options)
        : ''
      scope.model.customRecommendation = data.custom_recommendation
        .formattedText
        ? mustache.render(data.custom_recommendation.formattedText, options)
        : ''

      //strip new line placeholders
      scope.model.ruleReferences = data.rule_references.formattedText
        ? mustache.render(
            data.rule_references.formattedText.replace(/{{{nl}}}/g, ' '),
            options
          )
        : ''

      //strip new line placeholders
      scope.model.ruleCustomReferences = data.custom_rule_references
        .formattedText
        ? mustache.render(
            data.custom_rule_references.formattedText.replace(/{{{nl}}}/g, ' '),
            options
          )
        : ''
    }

    function selectProperty(scope, name) {
      if (scope.propertyOpen[name]) {
        scope.propertyOpen[name] = false
        scope.propertiesOpen--
      } else {
        scope.propertyOpen[name] = true
        scope.propertiesOpen++
      }
    }

    function showAllStacktraces(event) {
      event.details.last_custom_frame_min = event.details.last_custom_frame
      event.details.last_custom_frame = event.details.stacktraces.length
    }

    function showLessStacktraces(event) {
      event.details.last_custom_frame = event.details.last_custom_frame_min
    }

    function getHttpRequest(scope, data) {
      if (!angular.isUndefined(data.reason)) {
        //broadcast hide tab event
        $rootScope.$broadcast(VULN_REQUEST_EVENTS.HIDE_TAB, true)
        scope.model.text = data.reason
      } else {
        //  CONTRAST-37002 - In order to have the Prism highlighter and Mustache templates work, replace the {{{nl}}} section with a \n
        //  Otherwise, it will not be highlighted due to Prism looking for the new line indicator and not a mustache section template
        if (data.http_request && data.http_request.formattedText) {
          // TS-6477 MLY - current, this will do nothing (is it ok to leave it here as a placeholder?);
          // the response from the API for this request does not contain formattedTextVariables JSON element
          // we'll want to start using this & templating the mustache from the API accordingly to centralize
          // and simplify string sanitization.
          var options = data.http_request.formattedTextVariables
          if (options == undefined) {
            options = {}
          }
          var httpRequestData = data.http_request.formattedText.replace(
            new RegExp('{{{nl}}}', 'g'),
            '\n'
          )

          // TODO reverted -> https://bitbucket.org/contrastsecurity/contrast-ui/pull-requests/1162/ts-4316-stored-xss-in-assess-vulnerability/diff#comment-171748565
          // due to TS-5464
          httpRequestData = syntaxHighlighter.highlight(httpRequestData, 'http')

          scope.model.text = httpRequestData
            ? mustache.render(
                httpRequestData,
                angular.extend(traceRenderers, options)
              )
            : ''
        } else {
          scope.model.text = ''
        }
      }
    }

    function getContentTypeValueFromHeaders(headers) {
      var contentTypeHeader = _.find(headers, function (header) {
        return header.name.toLowerCase() === 'content-type'
      })

      return !angular.isUndefined(contentTypeHeader)
        ? contentTypeHeader.value
        : undefined
    }

    function shouldSendBodyAsData(method, contentType) {
      if (method === 'POST' && !angular.isUndefined(contentType)) {
        var ct = contentType.toLowerCase()
        return ct.includes('application/json') || ct.includes('text/xml')
      }

      return false
    }

    // for more info about this method logic see comments in https://contrast.atlassian.net/browse/TS-1339
    function replay(scope) {
      var url = scope.model.url
      var method = scope.model.method
      var body = scope.model.body
      var params = scope.model.parameters
      var headers = scope.model.headers
      var contentTypeValue = getContentTypeValueFromHeaders(headers)

      if (shouldSendBodyAsData(method, contentTypeValue)) {
        // use $http to send message-body as JSON
        $http
          .post(url, body)
          .then(function (response) {
            var tab = $window.open('', '_blank')
            tab.document.title = url
            tab.document.body.innerHTML = JSON.stringify(response)
          })
          .catch(function () {
            logger.logError($translate.instant('detail_requestError'))
          })
      } else {
        // use auto-submit-form to send message-body as form params
        var formParams = []

        // when empty params and content-type is form and body is a valid JSON
        if (
          (!Array.isArray(params) ||
            (Array.isArray(params) && params.length === 0)) &&
          !!contentTypeValue &&
          contentTypeValue
            .toLowerCase()
            .includes('application/x-www-form-urlencoded') &&
          isValidJSONString(body)
        ) {
          var jsonBody = JSON.parse(body)

          var bodyParams = Object.keys(jsonBody).map(function (key) {
            return { name: key, value: jsonBody[key] }
          })

          angular.forEach(bodyParams, function (param) {
            formParams.push(param)
          })
        }

        angular.forEach(params, function (param) {
          if (param.name != '' && param.value != '') {
            formParams.push({ name: param.name, value: param.value })
          }
        })

        //if GET method, remove query string and send parameters as form data
        if (method === 'GET') {
          var urlparts = url.split('?')
          if (urlparts.length >= 2) {
            url = urlparts[0]
          }
          //process query string, add parameters as hidden inputs
          var tokens = url.split('?')
          url = tokens[0]

          if (tokens.length == 2) {
            var qs = tokens[1]
            // replace plus signs in the query string with spaces
            var queryString = qs.replace(/\+/g, ' ')
            // split the query string around ampersands and semicolons
            var queryComponents = queryString.split(/[&;]/g)

            // loop over the query string components
            for (var index = 0; index < queryComponents.length; index++) {
              // extract this component's key-value pair
              var keyValuePair = queryComponents[index].split('=')
              var key = decodeURIComponent(keyValuePair[0])
              var value =
                keyValuePair.length > 1
                  ? decodeURIComponent(keyValuePair[1])
                  : ''

              formParams.push({ name: key, value: value })
            }
          }
        }

        var data = {
          redirectUrl: $sce.trustAsResourceUrl(url),
          redirectMethod: method,
          redirectData: formParams
        }

        $rootScope.$broadcast('trace.replay', data)
      }
    }

    function isValidJSONString(str) {
      if (str === '') {
        return false
      }

      try {
        JSON.parse(str)
      } catch (e) {
        return false
      }
      return true
    }

    function getTraceServer(scope, servers) {
      scope.model.servers = servers
    }

    function getTraceRequirements(scope, requirements) {
      scope.model.requirements = requirements
    }

    function getTraceRoutes(scope, routes) {
      scope.model.routes = routes
    }

    function getVulnerabilityInstanceMetadata(scope, sessionMetadata) {
      scope.model.session = sessionMetadata
    }

    function getVulnerabilityInstancesDetails(scope, instances) {
      scope.model.instances = instances
    }

    function getTrace(scope, trace) {
      scope.model.trace = trace
    }

    function loadNotes(scope, notes) {
      scope.model.notes = notes
      angular.forEach(scope.model.notes, function (note) {
        note.unsafe = he.decode(note.note)
      })

      if (scope.model.discussionCount) {
        scope.model.discussionCount.totalActivity = notes.length
      }
    }

    function compareDates(note) {
      return note.creation == note.last_modification
    }

    function securityControlDialog(substatus, preloadValues) {
      if (
        permissions.hasPermission('RULES_ADMIN') &&
        substatus == 'Goes through an internal security control'
      ) {
        dialogs
          .confirm(
            'Security Control Confirmation',
            'You marked this vulnerability as <b>going through an internal security control.</b> Would you like to define that security control now and make your future findings more accurate?',
            {
              size: 'md',
              no: 'No Thanks',
              yes: 'Create Security Control'
            }
          )
          .result.then(function () {
            $uibModal.open({
              templateUrl: 'views/rules/modal_control.html',
              controller: 'ModalAddControlInstanceCtrl',
              resolve: {
                preloadValuesData: function () {
                  return preloadValues
                }
              }
            })
          })
      }
    }
  }
})()
